import React from 'react'
import styles from './size-info.module.scss'
import image from '../../../assets/images/size-info/tee.png'
import styled from 'styled-components'

function Tee() {
  return (
    <div className={styles.sizeInfo}>
      <div>
        <h2 className={styles.sizeInfoTitle}>
          Используя вашу самую удобную футболку/майку/толстовку:
        </h2>
      </div>
      <Container columns="4fr 8fr">
        <div className={styles.sizeInfoImage}>
          <img loading="lazy" src={image} />
        </div>
        <div>
          <ol>
            <li>Измерьте ширину от подмышки (проймы) до подмышки (в см)</li>
            <li>Измерьте ширину от плеча до плеча (в см)</li>
            <li>Измерьте длину от верхней точки плеча до низа (в см)</li>
            <li>
              Используйте размер из таблицы наиболее подходящий вашим меркам
            </li>
          </ol>
        </div>
      </Container>
    </div>
  )
}

const Container = styled.div`
  @media (min-width: 940px) {
    display: grid;
    grid-template-columns: ${(p) => p.columns};
  }
`

Tee.propTypes = {}

export default Tee
